import axios from 'axios'
export default {
  /**
   * 增加短信模板
   * @typedef AddSmsTemplateParams
   * @property {number} templateType 模板类型
   * @property {string} templateName 模板名称
   * @property {string} templateContent 模板内容。长度为1~500个字符。模板内容需要符合文本短信模板规范或国际/港澳台短信模板规范.
   * @property {string} remark 短信模板申请说明。描述您的业务使用场景，长度为1~100个字符
   * @param {AddSmsTemplateParams} params
   */
  addSmsTemplate(params) {
    return axios.post('/api/rendering/admin/front/user/sms/template/addSmsTemplate', params)
  },
  /**
   * 删除申请短信模板
   * @typedef DeleteSmsTemplateParams
   * @property {string} id 模板主键id.
   * @param {DeleteSmsTemplateParams} params
   */
  deleteSmsTemplate(params) {
    return axios.post('/api/rendering/admin/front/user/sms/template/deleteSmsTemplate', params)
  },
  /**
   * 修改短信模板
   * @typedef ModifySmsTemplateParams
   * @property {number} templateType 模板类型
   * @property {string} templateName 模板名称
   * @property {string} templateContent 模板内容。长度为1~500个字符。模板内容需要符合文本短信模板规范或国际/港澳台短信模板规范.
   * @property {string} remark 短信模板申请说明。描述您的业务使用场景，长度为1~100个字符
   * @param {ModifySmsTemplateParams} params
   */
  modifySmsTemplate(params) {
    return axios.post('/api/rendering/admin/front/user/sms/template/modifySmsTemplate', params)
  },
  /**
   * 查询短信模板
   * @typedef QueryTemplateListParams
   * @property {number} [templateStatus] 审核状态 0：审核中。1：审核通过。2：审核失败
   * @property {number} [templateType] 模板类型 0：验证码。1：短信通知。2：推广短信。3：国际/港澳台消息。
   * @typedef TemplateSMSInfo
   * @property {number} id 记录id
   * @property {number} templateType 模板类型
   * @property {number} templateCode 短信模板CODE
   * @property {number} templateStatus 短信审核状态
   * @property {string} templateName 模板名称
   * @property {string} templateContent 模板内容。长度为1~500个字符。模板内容需要符合文本短信模板规范或国际/港澳台短信模板规范.
   * @property {string} remark 短信模板申请说明。描述您的业务使用场景，长度为1~100个字符
   * @property {string} operator 操作人
   * @property {string} reason 审核未通过原因
   * @property {string} requestId 请求ID
   * @property {number} createTime 短信模板的创建时间
   * @property {number} updateTime 操作时间。修改时间
   * @typedef ResultInfo
   * @property {TemplateSMSInfo} data
   * @property {number} code
   *
   * @param {QueryTemplateListParams} params
   * @returns {ResultInfo}
   */
  queryTemplateList(params) {
    return axios.post('/api/rendering/admin/front/user/sms/template/queryTemplateList', params)
  },

  /**
   * 新增消息
   * @typedef AddMessageParams
   * @property {number} messageCategory 1.短信，2.邮件，3.公众号
   * @property {number} templateId 消息模版id
   * @property {number[]} userIds 用户id
   * @property {string} messageContent 消息内容
   * @property {string} [remark] 备注
   * @param {AddMessageParams} params
   */
  addMessage(params) {
    return axios.post('/api/rendering/admin/front/user/messageSend/addMessage', params)
  },
  /**
   * 删除消息
   * @typedef DeleteMessageParams
   * @property {string} id
   * @param {DeleteMessageParams} params
   */
  deleteMessage(params) {
    return axios.post('/api/rendering/admin/front/user/messageSend/deleteMessage', params)
  },
  /**
   * 重发消息
   * @typedef ResendMessageParams
   * @property {string} id
   * @param {ResendMessageParams} params
   */
  resendMessage(params) {
    return axios.post('/api/rendering/admin/front/user/messageSend/resendMessage', params)
  },
  //

  /**
   * 得到分页消息列表
   * @typedef GetMessagePageParams
   * @property {number} pageNum 页数
   * @property {number} pageSize 每页行数
   * @property {number} [messageCategory] 消息类别 1.短信，2.邮件，3.公众号
   * @property {numnber} [messageStatus] 消息状态，0.待发送，1.发送中，2.发送完成
   *
   * @typedef MessagePageItem
   * @property {number} id
   * @property {number} messageCategory 1.短信，2.邮件，3.公众号
   * @property {numnber} messageStatus 消息状态，0.待发送，1.发送中，2.发送完成
   * @property {number} templateId 消息模版id
   * @property {number} adminId 管理员id
   * @property {string} adminName 管理员名称
   * @property {number[]} userIds 用户id
   * @property {string} messageContent 消息内容
   * @property {string} remark 备注
   * @property {number} totalCount 总发送次数
   * @property {number} successCount 成功次数
   * @property {number} failCount 失败次数
   * @property {number} updateTime 最后操作时间
   *
   * @typedef MessagePageInfo
   * @property {number} pageNum 页数
   * @property {number} size 每页行数
   * @property {number} total 总条数
   * @property {number} pageCount 总页数
   * @property {MessagePageItem[]} items
   *
   * @param {GetMessagePageParams} params
   * @returns {MessagePageInfo}
   */

  getMessagePage(params) {
    return axios.post('/api/rendering/admin/front/user/messageSend/getMessagePage', params)
  },
  uploadUserIdFile(params) {
    return axios.post('/api/rendering/admin/front/user/messageSend/uploadUserIdFile', params, {
      headers: {
        'content-type': 'multipart/form-data;',
      },
    })
  },
  updateSendTime(params) {
    return axios.post('/api/rendering/admin/front/user/messageSend/updateSendTime', params)
  },
}
